export default {"src":"/_next/static/media/wasabi.25b1f9da.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};